import React, { useEffect, useState } from "react";
import config from "../../config";
import { useNavigate } from "react-router-dom";

const SampleRequestForm = () => {
  const [embeddFormLink, setEmbeddedFormLink] = useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const fetchForm = async () => {
      try {
        const response = await fetch(
          `${config.API_BASE_URL}config-options/sample_request_form_id`
        );
        const data = await response.json();
        setEmbeddedFormLink(data[0]?.config_value || ""); // Ensure fallback to empty if no form is set
      } catch (error) {
        console.error("Error Fetching Sample Request Form:", error);
      }
    };

    fetchForm();
    document.title = "Sample Request Form";
  }, []);

  const handleOpenForm = () => {
    window.open(
      "https://docs.google.com/forms/d/e/1FAIpQLSfafH3G3uLCkuZJPEb8kANh-46zMKSk5QA8ukiyCPmTv7S46Q/viewform?usp=preview",
      "_blank"
    );
  };

  return (
    <div style={styles.container}>
      <p style={styles.text}>
        The button below will open the form in a new tab
      </p>
      <button style={styles.button} onClick={handleOpenForm}>
        Sample Request Form
      </button>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backgroundColor: "#f9fafb", // Light neutral background
    padding: "20px",
  },
  text: {
    fontSize: "1.2rem",
    color: "#333", // Darker gray for better readability
    marginBottom: "16px",
    fontWeight: 500,
  },
  button: {
    background: "linear-gradient(to right, #3b82f6, #1e40af)", // Gradient blue
    color: "white",
    fontSize: "1rem",
    fontWeight: "bold",
    padding: "12px 24px",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },
};

// Button Hover Effect
styles.buttonHover = {
  ...styles.button,
  background: "linear-gradient(to right, #2563eb, #1e3a8a)",
  transform: "translateY(-2px)",
  boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.15)",
};

export default SampleRequestForm;
